/** блок адаптации **/
import './common/adapterFromOldStyle'
/** блок адаптации **/

import './shares/style.css';
import './catalog/style.css';
import './catalog/filter/style.css';
import './pagenavigation/style.css';

import {Filter} from "./catalog/filter";
import {ShareList} from './shares/share.list';
import {ProductList} from "./catalog/product.list";
import Sorting from './components/categoryPage/sorting/Sorting';
import React, {lazy, Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import {eventEmitter, lang, langSiteDir, pageMeta, sessid} from './common/baseData';
import ViewedProductsSlider from './components/viewedProductsSlider/ViewedProductsSlider'
const TimeRemaining = lazy(() => import('./components/productPage/specialDealTimer/TimeRemaining'))

//Sort
let catalogSortBlock = document.querySelector('[data-container="page-sort"]');
if (catalogSortBlock instanceof HTMLElement) {
    try {
        let params = JSON.parse(atob(catalogSortBlock.dataset['params']));
        createRoot(catalogSortBlock).render(
            <Sorting options={params.sortValues}
                     messages={params.messages}
                     onChange={option => {
                         if (option.queryString) location.href = option.queryString;
                     }}/>
        );
    } catch (e) {
        console.error(e);
    }
}

// Filter logic
let filterBlock = document.querySelector('.filter__container');
if (filterBlock instanceof HTMLElement) {

    try {

        let checkboxList = filterBlock.querySelectorAll('[type="checkbox"]');
        if(checkboxList.length > 0) {
            for(let i = 0; i < checkboxList.length; i++) {
                if(!checkboxList[i].hasAttribute('checked'))
                    checkboxList[i].checked = false;
            }
        }

        let params = JSON.parse(atob(filterBlock.dataset['params']));
        let filter = new Filter(params);
        filter.markCategoryParents();
        filter.showSelectedCategoryPaths();
        /** Init filter events **/
        // Change values event
        filter.form.addEventListener('valuesChanged', (e) => {
            filter.onValuesChanged(e);
        });
        // Filter toggle
        let filterLink = document.querySelector('.filter-link');
        if (filterLink instanceof HTMLElement) {
            filterLink.addEventListener('click', (e) => {
                e.preventDefault();
                filter.open();
            });
        }

        // Закрытие фильтра по клику вне блока
        document.addEventListener('click', (e) => {
            let filterSection = document.querySelector('.filter-section');
            let filterLinkElement = document.querySelector('.filter-link');

            if (filterSection &&
              filterSection.classList.contains('opened') &&
              !filterSection.contains(e.target) &&
              (!filterLinkElement || !filterLinkElement.contains(e.target))) {
                filter.close();
            }
        });

        // Checkbox change event
        filter.form.addEventListener('change', (e) => {
            let element = e.target;
            if (element.dataset.block === 'property-value') { // Reload filter
                let event = new CustomEvent('valuesChanged', {detail: {element: element}});
                filter.form.dispatchEvent(event);
            } else if (element.classList.contains('min-price')) { // Min price filter
                // User set so much big value
                if (parseInt(filter.rangeMinPriceElement.value, 10) > parseInt(filter.rangeMaxPriceElement.value, 10)) {
                    filter.rangeMinPriceElement.value = filter.rangeMaxPriceElement.value;
                } else if (parseInt(filter.rangeMinPriceElement.value, 10) < filter.rangeMinPrice) {
                    filter.rangeMinPriceElement.value = filter.rangeMinPrice;
                }
                if (filter.priceSliders) filter.priceSliders.min.value = filter.rangeMinPriceElement.value;
                let event = new CustomEvent('valuesChanged', {detail: {element: element}});
                filter.form.dispatchEvent(event);
            } else if (element.classList.contains('max-price')) { // Max price filter
                // User set so much little value
                if (parseInt(filter.rangeMinPriceElement.value, 10) > parseInt(filter.rangeMaxPriceElement.value, 10)) {
                    filter.rangeMaxPriceElement.value = filter.rangeMinPriceElement.value;
                } else if (parseInt(filter.rangeMaxPriceElement.value, 10) > filter.rangeMaxPrice) {
                    filter.rangeMaxPriceElement.value = filter.rangeMaxPrice;
                }
                if (filter.priceSliders) filter.priceSliders.max.value = filter.rangeMaxPriceElement.value;
                let event = new CustomEvent('valuesChanged', {detail: {element: element}});
                filter.form.dispatchEvent(event);
            }
        });

        // Form click events
        filter.form.addEventListener('click', (e) => {
            let element = e.target;
            let categoryText = element.closest('[data-category-item] .checkbox-text');
            if (categoryText) {
                let checkboxAreaWidth = 24;
                if (e.clientX - categoryText.getBoundingClientRect().left <= checkboxAreaWidth) return;
                e.preventDefault();
                let categoryInput = categoryText.closest('[data-category-item]').querySelector('[data-property-code="CATEGORY"]');
                if (categoryInput && !categoryInput.disabled) filter.onCategoryTextClick(categoryInput);
            } else if (element.classList.contains('filter-box__title')) { // Hide all values
                filter.hideAllValues(element);
            } else if (element.classList.contains('show_more_js')) { // Show additional values
                filter.showAdditionalValues(element);
            } else if (element.classList.contains('hide_more_js')) { // Hide additional values
                filter.hideAdditionalValues(element);
            } else if (element.classList.contains('close-filter')) { // Close filter
                filter.close();
            } else if (element.classList.contains('popup-result__title')) { // Move to filtered page
                window.location.href = element.dataset.url;
            }
        });
    } catch (e) {
        console.error(e);
    }
}

//Share List
let shareListNode = document.querySelector('.shares-list');
if ((shareListNode instanceof HTMLElement) && shareListNode.hasAttribute('data-params')) {
    let params = JSON.parse(atob(shareListNode.getAttribute('data-params')));
    params.node = shareListNode;
    let shareList = new ShareList(params);

    let catalogPaginationBlock = document.querySelector('[data-container="page-paging"]');
    if (catalogPaginationBlock instanceof HTMLElement) {
        try {
            import(/* webpackPreload: true */ './pagenavigation')
              .then(({default: CatalogPagenation}) => {
                let params = JSON.parse(atob(catalogPaginationBlock.dataset['params']));
                params.node = catalogPaginationBlock;
                shareList.pagen = new CatalogPagenation(params);
                shareList.pagen.init();

                eventEmitter.on('show-more', (e) => {
                    if (typeof shareList.pagen !== 'object') return;
                    try {
                        if (!shareList.pagen.lazy || shareList.pagen.getCurrentPage() >= shareList.pagen.getLastPage()) return;
                        shareList.loadNextPage().then((response) => {
                            shareList.params.node.insertAdjacentHTML('beforeEnd', response);
                            shareList.pagen.setNextPageNumber();
                            shareList.pagen.activePageNode();
                            if (shareList.pagen.isLastPage) shareList.pagen.hideShowMoreButton();
                        });
                    } catch (error) {
                        console.error(error);
                    }
                });
            });
        } catch (e) {
            console.error(e);
        }
    }
}

// Products list
let productList;
let catalogProductBlock = document.querySelector('[data-container="product-list"]');
if (catalogProductBlock instanceof HTMLElement) {
    try {
        let params = JSON.parse(atob(catalogProductBlock.dataset['params']));
        params.node = catalogProductBlock;
        productList = new ProductList(params);

        //Basket events
        catalogProductBlock.addEventListener('click', (e) => {
            try {
                if(!e.target.hasAttribute('data-type') || e.target.getAttribute('data-type') !== 'addToCart') return;
                let button = e.target;
                eventEmitter.emit('addToCart', {productId: button.getAttribute('data-productid')});
            } catch (e) {
                console.error(e);
            }
        });

        eventEmitter.on('addedToCart', (data) => {
            try {
                if(!data.hasOwnProperty('productId')) return;
                let productId = data['productId'];
                let button = catalogProductBlock.querySelectorAll('.buy-btn_mini[data-type="addToCart"][data-productId="'+productId+'"]');
                if(button.length > 0) {
                    for(let i = 0; i < button.length; i++) {
                        button[i].classList.add('in-basket');
                    }
                }
            } catch (e) {
                console.error(e);
            }
        });

        eventEmitter.on('removedCartItem', (data) => {
            if(!data.hasOwnProperty('productId')) return;
            let productId = data['productId'];
            let button = catalogProductBlock.querySelectorAll('.in-basket[data-type="addToCart"][data-productId="'+productId+'"]');
            if(button.length > 0) {
                for(let i = 0; i < button.length; i++) {
                    button[i].classList.remove('in-basket');
                }
            }
        });

        // Wish list items update state
        eventEmitter.emit('handleWishlistItems', {
            node: catalogProductBlock.querySelectorAll('[data-container="favorite"]'),
            range: 'category'
        });

        eventEmitter.emit('handleCompareItems', {
            node: catalogProductBlock.querySelectorAll('[data-container="compare"]'),
            range: 'category'
        });

        // Pagination
        let catalogPaginationBlock = document.querySelector('[data-container="page-paging"]');
        if (catalogPaginationBlock instanceof HTMLElement) {
            let params = JSON.parse(atob(catalogPaginationBlock.dataset['params']));
            import(/* webpackPreload: true */ './pagenavigation')
              .then(({default: CatalogPagenation}) => {
                params.node = catalogPaginationBlock;
                productList.pagen = new CatalogPagenation(params);
                productList.pagen.init();

                eventEmitter.on('show-more', (e) => {
                    if (typeof productList.pagen !== 'object') return;
                    try {
                        if (!productList.pagen.lazy || productList.pagen.getCurrentPage() >= productList.pagen.getLastPage()) return;
                        productList.loadNextPage().then((response) => {
                            productList.params.node.insertAdjacentHTML('beforeEnd', response);
                            productList.pagen.setNextPageNumber();
                            productList.pagen.activePageNode();
                            if (productList.pagen.isLastPage) productList.pagen.hideShowMoreButton();
                            // Wish list items update state
                            eventEmitter.emit('handleWishlistItems', {
                                node: catalogProductBlock.querySelectorAll('[data-container="favorite"]'),
                                range: 'category'
                            });

                            eventEmitter.emit('handleCompareItems', {
                                node: catalogProductBlock.querySelectorAll('[data-container="compare"]'),
                                range: 'category'
                            });
                        });
                    } catch (error) {
                        console.error(error);
                    }

                });
            });
        }
    } catch (e) {
        console.error(e);
    }
}

// copy indication promocode
let shareLinkNode = document.querySelector('.promocode__row');
if (shareLinkNode instanceof HTMLElement) {
    import(/* webpackPreload: true */ 'clipboard-copy')
      .then(({default: clipboardCopy}) => {
        let shareBlock = shareLinkNode.querySelector('.copy-link');
        let shareLink = shareLinkNode.querySelector('.promocode');
        let shareLinkSaved = shareLinkNode.querySelector('.article-saved');
        shareBlock.addEventListener('click', e => {
            console.log(shareLink.textContent);
            clipboardCopy(shareLink.textContent);
            shareBlock.classList.remove('active');
            shareLinkSaved.classList.add('active');
            setTimeout(() => {
                shareBlock.classList.add("active");
                shareLinkSaved.classList.remove('active');
            }, 3000);
        });
    });
}

let specialDealRules = document.querySelector('.special-deal-rules')
if (specialDealRules instanceof HTMLElement) {
    specialDealRules.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()

        let rawText = specialDealRules.getAttribute('data-text');

        let descriptionText = '';
        try {
            descriptionText = JSON.parse(rawText);
        } catch (e) {
            descriptionText = rawText;
        }

        // формируем и показываем окно с описанием
        import(/* webpackPreload: true */ '/popup')
          .then(module => {
              let popup = new module.Popup('special-deal-rules-popup', false, false)
              // Устанавливаем тело окна
              popup.body =
                `<div class="protect-guarantee-popup-body">${decodeHtmlEntities(descriptionText)}</div>`
              popup.open()
          })
    })
}

function decodeHtmlEntities(text) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    return doc.documentElement.textContent;
}

if (document.querySelector('.countdown') instanceof HTMLElement) {
    import(/* webpackPreload: true */ './shares/countdown')
      .then(({CountDown}) => {
        CountDown.init();
    });
}

// special deal timer
let specialDealTimerContainer = document.getElementById('special-deal-data-active');
if (specialDealTimerContainer instanceof HTMLElement) {
    let specialDealTimerContainerParams = {
        componentParams: {
            active: specialDealTimerContainer.dataset.active,
            starting: specialDealTimerContainer.dataset.starting,
            lang: lang,
            sessid: sessid
        }
    };

    const timerRoot = createRoot(specialDealTimerContainer)
    timerRoot.render(<Suspense fallback={<></>}><TimeRemaining {...specialDealTimerContainerParams}/></Suspense>)
}

// Просмотренные твоары
new ViewedProductsSlider().init()